import {Component, ElementRef, Inject, OnInit, Renderer2, ViewChild} from '@angular/core';
import {FormBuilder, FormGroup, Validators} from '@angular/forms';
import {EvrakService} from '../_services/evrak.service';
import {CaptchaComponent} from 'angular-captcha';
import Cleave from 'cleave.js';
import {saveAs} from 'file-saver';
import {NgxUiLoaderService} from 'ngx-ui-loader';

declare var $: any;

@Component({
  selector: 'app-home',
  templateUrl: './home.component.html',
  styleUrls: ['./home.component.css']
})
export class HomeComponent implements OnInit {

  evrakForm: FormGroup;

  error;

  submitted = false;

  @ViewChild(CaptchaComponent, {static: false}) captchaComponent: CaptchaComponent;

  constructor(private formBuilder: FormBuilder,
              private evrakService: EvrakService,
              private ngxService: NgxUiLoaderService) {
  }

  ngOnInit() {
    this.evrakForm = this.formBuilder.group({
      evrakNo: ['', Validators.required],
      captchaCode: ['', Validators.required]
    });

    /**
     * Resimlerin arka kısımda slide olması için yapıldı.
     */
    let count = 0;
    const images = ['../../assets/admin/pages/media/bg/1.jpg', '../../assets/admin/pages/media/bg/2.jpg',
      '../../assets/admin/pages/media/bg/3.jpg', '../../assets/admin/pages/media/bg/4.jpg', '../../assets/admin/pages/media/bg/5.jpg'];
    const image = $('.login');

    image.css('background-image', 'url(' + images[count] + ')');

    setInterval(() => {
      image.css('background-image', 'url(' + images[count++] + ')');
      if (count === images.length) {
        count = 0;
      }

    }, 10000);

    /**
     * Input'u yedili grupluyor
     */
    const cleaveInput = new Cleave('#evrakNo', {
      blocks: [7, 7, 7, 7],
      delimiter: '-',
    });
  }

  evrakFormOnSubmit(event) {
    let evrakNo  = this.evrakForm.get('evrakNo').value != null ? this.evrakForm.get('evrakNo').value : '';
    evrakNo = evrakNo.split('-').join('');
    const captchaCode = this.captchaComponent != null ? this.captchaComponent.userEnteredCaptchaCode : '';
    const captchaId = this.captchaComponent != null ? this.captchaComponent.captchaId : '';
    this.submitted = true;
    if (this.evrakForm.invalid) {
      this.error = 'Lütfen formu kontrol edin!';
      return;
    }
    event.preventDefault();
    this.ngxService.start();
    this.evrakService.getEvrak(evrakNo, captchaCode, captchaId).subscribe(
      (data: any) => {
        if (data.size > 0) {
          const blob: any = new Blob([data], {type: 'application/octet-stream'});
          saveAs(blob, 'evrak.odt');
        }
        this.captchaComponent.reloadImage();
        this.ngxService.stop();
      }, (err) => {
        if (err.status === 401) {
          this.error = 'Girilen karakterler Resim Doğrulama alanındaki karakterler ile eşleşmemektedir!';
        } else if (err.status === 404) {
          this.error = 'Evrak Bulunamadı!';
        } else {
          this.error = 'Bir sorun oluştu!';
        }
        this.captchaComponent.reloadImage();
        this.ngxService.stop();
      });
  }

  get f() {
    return this.evrakForm.controls;
  }

  captchaChange(event) {
    if (event.key === '.') {
      const audioImage = document.getElementById('myCaptchaStyle_SoundIcon');
      audioImage.click();
    }
  }

  captchaClick() {
    this.error = '';
  }

}
